import React, { useEffect, useState } from "react";
import DepositAndWithdrawal from "../Graph/DepositAndWithdrawal";
import MonthlyAvgBalance from "../Graph/MonthlyAvgBalance";
import BalanceFluctuation from "../Graph/BalanceFluctuation";
import TransactionType from "../Graph/TransactionType";
import CashFlowMargin from "../Graph/CashFlowMargin";
import IncomeConsistencyIndex from "../Graph/IncomeConsistencyIndex";
import ExpensePredictability from "../Graph/ExpensePredictability";
import InvestmentToIncome from "../Graph/InvestmentToIncome";
import LiquidRatio from "../Graph/LiquidRatio";
import CardItem from "../Components/CardItem";
import axios from "axios";
import ImageLoading from "../../../../components/ImageLoading";
import NoDataFound from "../../../../components/NoDataFound";

function Summary({ bank, id }) {
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [summaryData, setSummaryData] = useState({});

  const fetchSummary = async () => {
    if (bank !== null && bank !== undefined) {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const options = {
          url: `${process.env.REACT_APP_URL}/lender/v1/dashboard_analyser/${bank}/dictionary_value/summary`,
          method: "GET",
          headers: { Authorization: token },
        };
        const res = await axios(options);
        if (res.data.summary) {
          setSummaryData(res.data.summary);
          setNoData(false);
        } else {
          setSummaryData({});
          setNoData(true);
        }
      } catch (error) {
        setSummaryData({});
        setNoData(true);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    fetchSummary();
  }, [bank]);
  return (
    <>
      {loading && (
        <div className="w-full h-full flex items-center justify-center ">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-full flex items-center justify-center ">
          <NoDataFound />
        </div>
      )}
      {!loading && !noData && (
        <>
          {" "}
          <div className=" flex items-center justify-between mt-4">
            <CardItem
              name={"Avg Income"}
              viewButton={true}
              data={summaryData?.periodic}
              subItem={"average_monthly_income"}
            />
            <CardItem
              name={"Avg Expense"}
              viewButton={true}
              data={summaryData?.periodic}
              subItem={"average_monthly_expense"}
            />
            <CardItem
              name={"Avg Daily Balance"}
              data={summaryData?.periodic}
              viewButton={true}
              subItem={"average_daily_balance"}
            />
          </div>
          <div className=" mt-6">
            <div className=" flex justify-between">
              <DepositAndWithdrawal data={summaryData?.periodic} />
              <MonthlyAvgBalance data={summaryData?.periodic} />
            </div>
            <BalanceFluctuation data={summaryData?.periodic} />
            <div className=" flex justify-between mt-6">
              <TransactionType data={summaryData?.periodic} />
              <CashFlowMargin
                data={summaryData?.periodic}
                cushion={
                  summaryData?.static?.financial_health?.financial_cushion
                }
              />
            </div>
            <div className=" flex justify-between mt-6">
              <IncomeConsistencyIndex data={summaryData?.periodic} />
              <ExpensePredictability data={summaryData?.periodic} />
            </div>
            <div className=" flex justify-between mt-6">
              <InvestmentToIncome data={summaryData?.periodic} />
              <LiquidRatio data={summaryData?.periodic} />
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Summary;
